<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>Recherche avancée</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <form class="edit-form" (submit)="search()" [formGroup]="editForm" *ngIf="editForm && !isLoading">

      <app-autocomplete [control]="getControl('site')" [list]="sites" label="orders.list.site">
      </app-autocomplete>

      <mat-form-field class="productCode-field">
        <mat-label>Code à barres produit/échantillon</mat-label>
        <input matInput formControlName="scanCode">
      </mat-form-field>

      <mat-form-field class="transportDate-field">
        <mat-label>Date de transport</mat-label>
        <input matInput [matDatepicker]="transportDate" (click)="transportDate.open()" (focus)="transportDate.open()"
          formControlName="startDate">
        <mat-datepicker-toggle matSuffix [for]="transportDate"></mat-datepicker-toggle>
        <mat-datepicker #transportDate></mat-datepicker>
      </mat-form-field>

      <app-autocomplete [control]="getControl('productType')" [list]="productTypes"
        label="repository.containers.edit.productType.label">
      </app-autocomplete>

      <app-autocomplete class="driver-field" label="orders.list.driver" [control]="getControl('driver')"
        [list]="drivers">
      </app-autocomplete>

      <mat-form-field class="searchEverywhere-field">
        <mat-label>Rechercher partout</mat-label>
        <input matInput formControlName="globalFilter">
      </mat-form-field>

      <mat-form-field class="kooveaTag-field">
        <mat-label>N° tag koovea</mat-label>
        <input matInput formControlName="tag">
      </mat-form-field>

      <section class="actions">
        <button mat-raised-button *ngIf="!isLoading" type="submit" color="primary" [disabled]="">Appliquer
          filtre(s)</button>

        <button mat-icon-button color="primary" *ngIf="!editForm.pristine" matTooltip="Effacer les filtres"
          (click)="clearFilters()">
          <mat-icon>
            clear
          </mat-icon>
        </button>
      </section>

    </form>
  </mat-card-content>

</mat-card>

<section class="resultsSection" [hidden]="!results || isLoadingResults || orders.length === 0">
  <table mat-table [dataSource]="dataSource" matSort>

    <ng-container matColumnDef="identifier">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'orders.list.identifier' | translate}}
      </th>
      <td mat-cell *matCellDef="let order"> {{ order.identifier }} </td>
    </ng-container>

    <ng-container matColumnDef="type" *ngIf="isDispatcher">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="typeCell">
        {{ 'orders.list.type' | translate}}
      </th>
      <td mat-cell *matCellDef="let order"> {{ showTypeText(order.type) | translate }} </td>
    </ng-container>

    <ng-container matColumnDef="startDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'orders.list.startDate' | translate}}</th>
      <td mat-cell *matCellDef="let order">{{ order.startDate | amDateFormat: 'DD/MM/YYYY HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="urgency">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'orders.list.urgency' | translate}}
      </th>
      <td mat-cell *matCellDef="let order">
        <span *ngIf="order.urgency"> {{ order.urgency.name }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="sender">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'orders.list.sender' | translate}}
      </th>
      <td mat-cell *matCellDef="let order">
        <span *ngIf="order.sender.address"> {{ order.sender?.address.name }} </span>
        <span *ngIf="!order.sender.address"> {{ order.sender.otherAddress }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="receivers">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'orders.list.receiver' | translate}}
      </th>
      <td mat-cell *matCellDef="let order">
        <span *ngIf="order.receivers.length > 1">
          <span *ngIf="order.receivers[0].address"> {{ order.receivers[0].address.name }} (Multiples)</span>
          <span *ngIf="!order.receivers[0].address"> {{ order.receivers[0].otherAddress }} (Multiples)</span>
        </span>
        <span *ngIf="order.receivers.length === 1">
          <span *ngIf="order.receivers[0].address"> {{ order.receivers[0].address.name }}</span>
          <span *ngIf="!order.receivers[0].address"> {{ order.receivers[0].otherAddress }}</span>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="site">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Donneur d'ordre
      </th>
      <td mat-cell *matCellDef="let order">
        <span *ngIf="order.site"> {{ order.site?.name }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'orders.list.status' | translate}}
      </th>
      <td mat-cell *matCellDef="let order"> {{ showStatusText(order.status) | translate }} </td>
    </ng-container>

    <ng-container matColumnDef="client">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'orders.list.client' | translate}}
      </th>
      <td mat-cell *matCellDef="let order">
        <span *ngIf="order.client"> {{ order.client.name }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Créé par
      </th>
      <td mat-cell *matCellDef="let order"> {{ order.createdBy?.username }} </td>
    </ng-container>

    <ng-container matColumnDef="createdOn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Créé le </th>
      <td mat-cell *matCellDef="let order"> {{ order.createdOn | amDateFormat: 'DD/MM/YYYY HH:mm' }} </td>
    </ng-container>

    <ng-container matColumnDef="driver">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Chauffeur
      </th>
      <td mat-cell *matCellDef="let order">{{ order.driver?.username}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> {{ 'orders.list.actions' | translate }} </th>
      <td mat-cell *matCellDef="let order" class="tdActions">
        <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
          [matTooltip]="'orders.list.detail' | translate" (click)="onSelectOrder(order.id)">
          <mat-icon aria-label="Edit">zoom_in</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let mission; columns: displayedColumns;" class="mission" [ngClass]="{
          'disabled': mission.status === 32 || mission.isDeleted,
          'isTreated' : mission.status === 4,
          'inProgress' : mission.status === 128,
          'finished' : mission.status === 16
      }"></tr>
  </table>
  <mat-paginator class="paginator" [pageSizeOptions]="[20, 25, 50, 100]" showFirstLastButtons></mat-paginator>

</section>

<section class="resultsSection" *ngIf="results && !isLoadingResults && orders.length === 0">
  <p>Il n'y aucune commande correspondant à votre recherche.</p>
</section>
<mat-spinner *ngIf="isLoadingResults" [diameter]="35" color="primary" class="spinner"></mat-spinner>

<mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="accent">
</mat-progress-bar>